import { render, staticRenderFns } from "./ModalAskPaillettes.vue?vue&type=template&id=cef43410&"
import script from "./ModalAskPaillettes.vue?vue&type=script&lang=js&"
export * from "./ModalAskPaillettes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports